import React, { useEffect } from "react";

const FirebaseWrapper = ({ children }) => {

    useEffect(() => {
        import("../../firebase").then(firebase => {
            firebase.FireBase();
        });
    }, [])

    return (
        <>
            {children}
        </>
    );
}

export default FirebaseWrapper;
